import { DangerAlertIcon } from '../../icons';
import IconButton from '../IconButton';
import TooltipWrapper from '../TooltipWrapper';

export interface INotesErrorButtonProps {
  tooltipText: string;
  onClick: () => void;
}

const NotesErrorButton = ({ tooltipText, onClick }: INotesErrorButtonProps) => {
  return (
    <TooltipWrapper tooltipText={tooltipText} tooltipPosition='left'>
      <IconButton onClick={onClick} icon={<DangerAlertIcon />} />
    </TooltipWrapper>
  );
};

export default NotesErrorButton;
